// src/components/ApplicationCard.jsx
import { useTranslation } from "react-i18next";
import LocalizedLink from "./LocalizedLink";

export default function ApplicationCard({ app }) {
  const { t } = useTranslation();

  const name  = t(`applications.catalog.${app.slug}.name`);
  const blurb = t(`applications.catalog.${app.slug}.blurb`);
  const price = t(`applications.catalog.${app.slug}.price`);

  const ASSET = (p) => `${process.env.PUBLIC_URL || ""}${p}`;

  // Fallbacks (adjust to your structure if needed)
  const coverSrc = app.image || ASSET(`/appointments/${app.slug}/cover.png`);
  const logoSrc  = app.logo  || ASSET(`/appointments/${app.slug}/logo.svg`);

  const Avatar = () =>
    logoSrc ? (
      <img
        src={logoSrc}
        alt={`${name} logo`}
        className="h-10 w-10 object-contain"
        loading="lazy"
      />
    ) : (
      <div className="h-10 w-10 grid place-items-center rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white font-bold">
        {name?.[0]?.toUpperCase() || "A"}
      </div>
    );

  return (
    <article className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm hover:shadow-md transition h-full flex flex-col">
      {/* Cover */}
      <div className="aspect-[16/9] w-full bg-slate-50 border-b border-slate-100 overflow-hidden">
        {coverSrc ? (
          <img
            src={coverSrc}
            alt={`${name} preview`}
            className="h-full w-full object-cover group-hover:scale-[1.02] transition-transform"
            loading="lazy"
          />
        ) : (
          <div className="h-full w-full grid place-items-center text-slate-400">
            <span className="text-sm">{name}</span>
          </div>
        )}
      </div>

      {/* Body */}
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-center gap-3">
          <Avatar />
          <div>
            <h3 className="text-lg font-semibold text-slate-900">{name}</h3>
            {price && <p className="text-[13px] text-slate-600">{price}</p>}
          </div>
        </div>

        {blurb && <p className="mt-3 text-slate-700">{blurb}</p>}

        {/* Actions pinned to bottom */}
        <div className="mt-auto pt-5 flex flex-wrap gap-2">
          <LocalizedLink
            to={`/applications/${app.slug}`}
            className="rounded-xl bg-indigo-600 px-4 py-2 text-white text-sm font-medium hover:bg-indigo-700"
          >
            {t("applications.cta.details")}
          </LocalizedLink>

          <LocalizedLink
            to="/contact"
            className="rounded-xl border border-slate-300 px-4 py-2 text-sm font-medium hover:bg-slate-50"
          >
            {t("applications.cta.contact")}
          </LocalizedLink>
        </div>
      </div>
    </article>
  );
}
